import { ButtonPosition } from '@/common/manager/position/button-position';
import isPlainObject from 'lodash/isPlainObject';
export const config = {
    value: 'setFormData',
    position: [
        ButtonPosition.formDialogSubmitAfterRequestSuccess,
        ButtonPosition.formSubmitAfterRequestSuccess,
    ],
    action: (arg) => {
        const { formInstance, response } = arg || {};
        if (formInstance && response) {
            const { success, data } = response;
            if (success && isPlainObject(data)) {
                formInstance.setValues?.(data, 'overwrite');
            }
        }
    },
};
